<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      @if (!loading) {
        <div class="ui-g card mt-4">
          <div class="ui-g-12 ui-md-12 ui-lg-12 mt-3">
            <div class="engactivity">
              <table>
                <tr>
                  <td class="engtdpanel">
                    Requested Profiles <br /><span>{{
                      paymentProfileCount.requestedProfiles
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Submitted Profiles <br /><span>{{
                      paymentProfileCount.submittedProfiles
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
